"use client";

import Link from "next/link";
import { Bookmark, Trash2, ExternalLink } from "lucide-react";
import { useBookmarks } from "@/lib/bookmarks";
import { SUBSPECIALTIES } from "@/lib/constants";

export function BookmarksClient() {
  const { bookmarks, removeBookmark } = useBookmarks();

  if (bookmarks.length === 0) {
    return (
      <div className="rounded-xl border border-dashed p-12 text-center text-muted-foreground">
        <Bookmark className="mx-auto mb-3 h-8 w-8 opacity-30" />
        <p className="font-medium">아직 저장한 질환이 없습니다</p>
        <p className="mt-1 text-sm">
          질환 페이지에서 북마크 아이콘을 클릭하면 여기에 저장됩니다
        </p>
      </div>
    );
  }

  // Group by subspecialty
  const grouped: Record<string, typeof bookmarks> = {};
  for (const bm of bookmarks) {
    if (!grouped[bm.subspecialty]) grouped[bm.subspecialty] = [];
    grouped[bm.subspecialty].push(bm);
  }

  return (
    <div className="space-y-6">
      <p className="text-sm text-muted-foreground">
        {bookmarks.length}개 질환이 저장되어 있습니다
      </p>

      {Object.entries(grouped).map(([sub, items]) => {
        const subInfo = SUBSPECIALTIES.find((s) => s.id === sub);
        return (
          <div key={sub}>
            <h2 className="text-sm font-semibold text-muted-foreground mb-2">
              {subInfo?.name || sub}
            </h2>
            <div className="space-y-1">
              {items
                .sort((a, b) => b.addedAt - a.addedAt)
                .map((bm) => (
                  <div
                    key={bm.slug}
                    className="flex items-center justify-between rounded-lg border bg-card px-4 py-3 hover:border-primary/30 transition-colors group"
                  >
                    <Link
                      href={`/${bm.subspecialty}/${bm.slug}`}
                      className="flex items-center gap-3 min-w-0 flex-1"
                    >
                      <Bookmark className="h-4 w-4 shrink-0 fill-primary text-primary" />
                      <span className="text-sm font-medium text-foreground truncate">
                        {bm.title}
                      </span>
                      <ExternalLink className="h-3.5 w-3.5 shrink-0 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                    <button
                      onClick={() => removeBookmark(bm.slug)}
                      className="ml-2 p-1.5 rounded-md text-muted-foreground hover:text-clinical-red hover:bg-clinical-red/10 transition-colors opacity-0 group-hover:opacity-100"
                      title="북마크 해제"
                    >
                      <Trash2 className="h-3.5 w-3.5" />
                    </button>
                  </div>
                ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
